import { __assign } from 'tslib';
import * as React from 'react';
import { useContext } from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-radio-button.css';

var UitkRadioButtonGroupContext = React.createContext(null);

var getClassNameList$1 = classNames.bind(styles);
var UitkRadioButton = function (props) {
    var _a, _b;
    var className = props.className, children = props.children, checked = props.checked, description = props.description, disabled = props.disabled, id = props.id, label = props.label, labelClassName = props.labelClassName, labelSuffix = props.labelSuffix, required = props.required, name = props.name, value = props.value, a11yLabel = props.a11yLabel;
    var RadioButtonGroupContext = useContext(UitkRadioButtonGroupContext);
    var baseCssClass = 'uitk-radio-button';
    var CssClassNameLabelSuffix = baseCssClass + "-label-haslabelsuffix";
    var wrapperClassNames = getClassNameList$1(baseCssClass, {
        'is-disabled': disabled
    });
    var labelCssClassNames = getClassNameList$1("uitk-radio-button-label", CssClassNameLabelSuffix, (_a = {},
        _a[labelClassName] = Boolean(labelClassName),
        _a['is-required'] = required,
        _a));
    var inputClassNames = getClassNameList$1({
        checked: checked
    }, className);
    var contents = label || children;
    var checkedProp = (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.defaultChecked) ? 'defaultChecked' : 'checked';
    var isChecked = checked || (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.selected) === value;
    return (React.createElement(UitkLayoutFlex, { className: wrapperClassNames, wrap: "nowrap" },
        React.createElement(UitkLayoutFlexItem, { className: getClassNameList$1(baseCssClass + "-content"), grow: 1 },
            React.createElement("div", null,
                React.createElement("label", { className: labelCssClassNames, htmlFor: id },
                    React.createElement("input", __assign({ type: "radio", name: name || (RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.group), id: id }, (_b = {}, _b[checkedProp] = isChecked, _b), { className: inputClassNames, onChange: RadioButtonGroupContext === null || RadioButtonGroupContext === void 0 ? void 0 : RadioButtonGroupContext.onChange, value: value, disabled: disabled })),
                    React.createElement("span", { "aria-hidden": "true", className: getClassNameList$1(baseCssClass + "-control") }),
                    React.createElement("span", { "aria-hidden": Boolean(a11yLabel), className: getClassNameList$1(baseCssClass + "-label-content") }, contents),
                    labelSuffix && (React.createElement("span", { "aria-hidden": Boolean(a11yLabel), className: getClassNameList$1(baseCssClass + "-label-suffix") }, labelSuffix)),
                    a11yLabel && React.createElement("span", { className: "is-visually-hidden" }, a11yLabel),
                    description && (React.createElement("p", { className: getClassNameList$1(baseCssClass + "-description uitk-type-200") }, description)))))));
};

var getClassNameList = classNames.bind(styles);
var UitkRadioButtonGroup = function (props) {
    var children = props.children, defaultChecked = props.defaultChecked, errorMessage = props.errorMessage, group = props.group, selected = props.selected, onChange = props.onChange;
    var wrapperClassNames = getClassNameList('uitk-radio-button-group');
    var errorClassNames = getClassNameList('uitk-radio-button-error');
    return (React.createElement("fieldset", { className: wrapperClassNames },
        React.createElement("legend", { className: "is-visually-hidden" }, group),
        errorMessage && React.createElement("p", { className: errorClassNames }, errorMessage),
        React.createElement(UitkRadioButtonGroupContext.Provider, { value: { onChange: onChange, defaultChecked: defaultChecked, group: group, selected: selected } }, children)));
};

export { UitkRadioButton, UitkRadioButtonGroup };
